import { useVoixAsyncData } from "@voix/voix-layer/composables/useVoixAsyncData";
export const $voixNuxtApi = async (request, options = {}) => {
  return await useVoixAsyncData(request, options);
};
